import { lazy } from 'react';

// Lazy load page components
export const EventDestinations = lazy(() => import('@/features/destinations/event-destinations'));

export const Orders = lazy(() => import('@/features/shopify/orders/orders'));

export const OrderDetails = lazy(async () => {
  const m = await import('@/features/shopify/orders/components/order-details/order-details');
  return {
    default: m.OrderDetails,
  };
});

export const Products = lazy(() => import('@/features/shopify/products/products'));

export const DestinationConfigPage = lazy(() => import('@/features/destinations/destination-config-page'));

// CustomTriggersPage consolidated into Destinations — keep redirect for bookmarks
export const DevelopmentPage = lazy(() => import('@/app/pages/development-page'));

export const AccountPage = lazy(() => import('@/features/settings/account/account-page'));

export const PasswordPage = lazy(() => import('@/features/settings/account/password-page'));

export const BillingSettings = lazy(() => import('@/features/billing/settings/billing-settings'));

export const InvoicesPage = lazy(() => import('@/features/billing/settings/invoices/invoices-page'));

export const PlansSettingsPage = lazy(
  () => import('@/features/billing/settings/plans/plans-settings-page')
);

export const UsageSettingsPage = lazy(
  () => import('@/features/billing/settings/usage/usage-settings-page')
);

export const PaymentMethodsSettingsPage = lazy(
  () => import('@/features/billing/settings/payment-methods/payment-methods-settings-page')
);

export const Acquisition = lazy(() => import('@/features/acquisition/acquisition'));

export const DiscountedSubscriptionPlan = lazy(() => import('@/features/billing/discounted-plans/discounted-plans'));

export const Cohorts = lazy(() => import('@/features/dashboard/ltv-cohort/ltv-cohort-page'));

export const Onboarding = lazy(() => import('@/features/setup/onboarding/onboarding'));

export const GetStartedRoute = lazy(() => import('@/features/setup/get-started/get-started-route'));

export const EventDebugger = lazy(() => import('@/features/events/event-debugger/event-debugger'));

export const ShopifySubscriptionPlans = lazy(
  () => import('@/features/shopify/subscription-plans/shopify-subscription-plans')
);

export const ShopifyPlanConfirm = lazy(
  () => import('@/features/shopify/subscription-plans/shopify-plan-confirm')
);

export const ShopifySubscriptionUpdate = lazy(
  () => import('@/features/shopify/update-subscription/shopify-subscription-update')
);

export const StripePlanSelection = lazy(() => import('@/features/billing/stripe/stripe-plan-selection'));

export const StripePlanConfirm = lazy(() => import('@/features/billing/stripe/stripe-plan-confirm'));

export const StripePlanSuccess = lazy(() => import('@/features/billing/stripe/stripe-plan-success'));

export const AuthCallback = lazy(() => import('@/features/integrations/auth-callback'));

export const SettingsLayout = lazy(() => import('@/features/settings/settings-layout'));

export const TeamManagementPage = lazy(() => import('@/features/team/team-management-page'));

export const NotificationsPage = lazy(() => import('@/features/settings/notifications/notifications-page'));

export const DashboardSettingsPage = lazy(() => import('@/features/settings/dashboard/dashboard-settings-page'));

export const NotificationCenterPage = lazy(
  () => import('@/features/notifications/notifications-page')
);

export const AttributionV2 = lazy(async () => {
  const m = await import('@/features/attribution/attribution');
  return { default: m.Attribution };
});

export const HomePage = lazy(() => import('@/features/home/home-page'));

export const HomeV2Page = lazy(() => import('@/features/home/home-v2/home-v2-page'));

export const Ecommerce = lazy(() => import('@/features/dashboard/ecommerce/ecommerce'));

export const PnlDashboard = lazy(() => import('@/features/dashboard/pnl/pnl-dashboard'));

export const IncomeStatementPage = lazy(() => import('@/features/dashboard/pnl/income-statement-page'));

export const HomeDashboard = lazy(() => import('@/features/dashboard/home-dashboard/home-dashboard'));

export const KPIDashboardPage = lazy(() => import('@/features/dashboard/kpi-dashboard/kpi-dashboard-page'));

export const CustomDashboard = lazy(() => import('@/features/dashboard/overview/dashboard-section'));

export const TrafficOverview = lazy(
  () => import('@/features/dashboard/traffic-overview/traffic-overview')
);

export const DataQualityDashboard = lazy(
  () => import('@/features/dashboard/data-quality/data-quality-dashboard')
);

export const EventsManagerPage = lazy(
  () => import('@/features/events/events-manager-page')
);

export const IntegrationsPage = lazy(async () => {
  const m = await import('@/features/integrations/integrations-page');
  return {
    default: m.IntegrationsPage,
  };
});

export const ShopifySetup = lazy(async () => {
  const m = await import('@/features/setup/shopify-setup/shopify-setup');
  return {
    default: m.ShopifySetup,
  };
});

export const BillingRecoveryPage = lazy(() => import('@/features/billing/settings/billing-recovery/billing-recovery-page'));

export const CostsPage = lazy(() => import('@/features/costs/costs-page'));

export const ApiKeysPage = lazy(() => import('@/features/settings/api-keys/api-keys-page'));

export const UtmTrackingPage = lazy(() => import('@/features/attribution/utm/utm-tracking-page'));

export const PixelSettingsStubPage = lazy(
  () => import('@/features/settings/pixel/pixel-settings-stub-page')
);

export const CustomEventMappingStubPage = lazy(
  () => import('@/features/settings/custom-event-mapping/custom-event-mapping-stub-page')
);

export const RollingReachDashboard = lazy(
  () => import('@/features/dashboard/rolling-reach/rolling-reach-dashboard')
);

export const ReachComparisonDashboard = lazy(
  () => import('@/features/dashboard/reach-comparison/reach-comparison-dashboard')
);

export const CumulativeReachDashboard = lazy(
  () => import('@/features/dashboard/cumulative-reach/cumulative-reach-dashboard')
);

export const RealtimeDashboard = lazy(() => import('@/features/realtime/realtime-dashboard'));
